import AssetsIssuance from "../../../views/AssetsIssuance";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const assetsIssuanceRoutes = [
  {
    menuName: MenuNames.ASSETS_ISSUANCE,
    path: "/assets-issuance",
    component: AssetsIssuance,
    exact: true,
  },
];

export default assetsIssuanceRoutes;
